import React from "react";

export const DrawChainIcon = ({
  width = 26.928,
  height = 26.925,
  fill = "#fff",
  className = "",
  ...rest
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      viewBox="0 0 26.928 26.925"
    >
      <g id="chain" transform="translate(0 0)">
        <path
          id="Path_13797"
          data-name="Path 13797"
          d="M7.227,24.446h-.9c0,.007-.009-.007-.01-.022-.038-.656-.038-.656-.683-.655H4.568c-.329,0-.4.058-.438.39-.013.1-.016.2-.027.328l-.888-.044a1.171,1.171,0,0,1,.488-1.1A2.817,2.817,0,0,1,5.534,23a2.237,2.237,0,0,1,1.2.4,1.174,1.174,0,0,1,.492,1.051"
          transform="translate(-1.625 -11.665)"
          fill={fill}
        />
        <path
          id="Path_13798"
          data-name="Path 13798"
          d="M47.608,24.453l-.908.012c-.018-.157-.026-.3-.053-.444a.3.3,0,0,0-.345-.273c-.459.011-.92,0-1.38,0-.322,0-.383.059-.421.377-.011.1-.01.2-.016.309l-.92-.088a1.117,1.117,0,0,1,.649-1.1,3.039,3.039,0,0,1,2.818.08,1.157,1.157,0,0,1,.577,1.128"
          transform="translate(-22.113 -11.644)"
          fill={fill}
        />
        <path
          id="Path_13799"
          data-name="Path 13799"
          d="M36.622,24.414c-.044-.824-.145-.632-.752-.648-.328-.009-.657,0-.985,0s-.405.059-.449.4c-.011.089-.012.18-.021.307l-.9-.039a1.251,1.251,0,0,1,1.037-1.351,3.438,3.438,0,0,1,2.107.094,1.245,1.245,0,0,1,.873,1.241l-.912-.006"
          transform="translate(-17.01 -11.657)"
          fill={fill}
        />
        <path
          id="Path_13800"
          data-name="Path 13800"
          d="M14.211,24.457l-.9-.032a1.171,1.171,0,0,1,.7-1.215,3.185,3.185,0,0,1,2.605.038,1.216,1.216,0,0,1,.719,1.212l-.905.007c-.094-.7-.094-.7-.8-.709-.329,0-.657,0-.986,0-.3,0-.388.079-.423.383-.012.1-.01.2-.015.318"
          transform="translate(-6.754 -11.65)"
          fill={fill}
        />
        <path
          id="Path_13801"
          data-name="Path 13801"
          d="M28.82,34.414c0-.3.008-.6.013-.891a1.252,1.252,0,0,1,1.389,1.035,3.384,3.384,0,0,1-.137,2.219,1.2,1.2,0,0,1-1.209.754c-.006-.293-.012-.586-.019-.893.142-.018.3-.029.445-.058a.273.273,0,0,0,.243-.312c-.009-.468,0-.936,0-1.4,0-.3-.053-.369-.356-.417-.1-.017-.211-.02-.369-.033"
          transform="translate(-14.629 -17.013)"
          fill={fill}
        />
        <path
          id="Path_13802"
          data-name="Path 13802"
          d="M28.923,43.593a1.161,1.161,0,0,1,1.22.833,3.187,3.187,0,0,1-.106,2.516,1.214,1.214,0,0,1-1.2.685q-.008-.468-.015-.881c.044-.028.058-.042.072-.043.628-.033.652-.06.649-.691,0-.362,0-.723,0-1.085,0-.3-.064-.371-.364-.408-.1-.013-.211-.012-.328-.019l.07-.906"
          transform="translate(-14.631 -22.128)"
          fill={fill}
        />
        <path
          id="Path_13803"
          data-name="Path 13803"
          d="M24.445,33.516c.011.31.022.6.032.9l-.183.007c-.48.024-.543.094-.539.571,0,.394,0,.788,0,1.182,0,.314.081.4.4.43.09.009.18.008.274.012-.021.3-.041.6-.062.907a1.118,1.118,0,0,1-1.111-.676,3.172,3.172,0,0,1-.044-2.624,1.166,1.166,0,0,1,1.233-.713"
          transform="translate(-11.649 -17.012)"
          fill={fill}
        />
        <path
          id="Path_13804"
          data-name="Path 13804"
          d="M47.627,28.923a1.217,1.217,0,0,1-.78,1.176,3.266,3.266,0,0,1-2.449.053,1.2,1.2,0,0,1-.808-1.252l.9-.014c.075.822.109.658.8.673.3.006.609-.015.911.006.412.03.46-.155.49-.477a1.731,1.731,0,0,0-.015-.236l.951.072"
          transform="translate(-22.126 -14.645)"
          fill={fill}
        />
        <path
          id="Path_13805"
          data-name="Path 13805"
          d="M6.305,28.894l.913.01a1.158,1.158,0,0,1-.693,1.172,3.181,3.181,0,0,1-2.538.08,1.217,1.217,0,0,1-.8-1.279l.909.031c.015.119.025.273.057.422a.278.278,0,0,0,.313.245c.468-.011.936,0,1.4-.006.318,0,.392-.075.425-.4.009-.089.009-.18.014-.276"
          transform="translate(-1.616 -14.658)"
          fill={fill}
        />
        <path
          id="Path_13806"
          data-name="Path 13806"
          d="M24.481,3.208c0,.293.008.587.012.885-.183.026-.337.038-.487.071a.28.28,0,0,0-.241.317c.009.468,0,.937,0,1.406,0,.3.063.372.361.412.1.014.21.014.323.02-.016.3-.032.595-.048.9a1.171,1.171,0,0,1-1.172-.738,3.28,3.28,0,0,1-.224-1.786,2.774,2.774,0,0,1,.206-.755,1.19,1.19,0,0,1,1.265-.728"
          transform="translate(-11.663 -1.627)"
          fill={fill}
        />
        <path
          id="Path_13807"
          data-name="Path 13807"
          d="M33.516,28.847l.952,0a.77.77,0,0,0-.04.166c.01.47.1.553.564.547.4-.006.805,0,1.207,0,.29,0,.377-.08.409-.365.012-.105.008-.212.011-.315l.918.014a1.149,1.149,0,0,1-.678,1.165,3.154,3.154,0,0,1-2.651.043,1.2,1.2,0,0,1-.693-1.248"
          transform="translate(-17.012 -14.641)"
          fill={fill}
        />
        <path
          id="Path_13808"
          data-name="Path 13808"
          d="M28.917,13.292a1.223,1.223,0,0,1,1.272.96,3.148,3.148,0,0,1-.178,2.437,1.2,1.2,0,0,1-1.177.64c0-.309,0-.6-.007-.905.169-.021.314-.032.456-.058a.3.3,0,0,0,.269-.343c-.013-.451,0-.9,0-1.354,0-.336-.09-.426-.43-.452-.081-.006-.163-.006-.257-.009.02-.3.038-.6.058-.915"
          transform="translate(-14.632 -6.747)"
          fill={fill}
        />
        <path
          id="Path_13809"
          data-name="Path 13809"
          d="M24.423,17.323a1.277,1.277,0,0,1-1.309-1.037,3.335,3.335,0,0,1,.019-2.086,1.229,1.229,0,0,1,1.278-.906q.017.449.033.9a.15.15,0,0,1-.046.02c-.622.023-.642.044-.641.669,0,.354,0,.707,0,1.061s.065.416.4.453c.089.01.18.009.305.015-.014.3-.028.6-.042.914"
          transform="translate(-11.653 -6.748)"
          fill={fill}
        />
        <path
          id="Path_13810"
          data-name="Path 13810"
          d="M24.408,47.618a1.259,1.259,0,0,1-1.29-1.034,3.329,3.329,0,0,1,.021-2.109,1.209,1.209,0,0,1,1.28-.885c0,.3.005.595.008.9.006,0-.008.01-.023.01-.647.036-.646.036-.644.685,0,.345,0,.69,0,1.035s.082.429.422.466c.081.009.163.009.3.015-.023.3-.046.6-.07.913"
          transform="translate(-11.653 -22.127)"
          fill={fill}
        />
        <path
          id="Path_13811"
          data-name="Path 13811"
          d="M13.285,28.887l.9-.019c.023.161.037.323.07.48a.244.244,0,0,0,.279.213c.476-.008.952,0,1.428,0,.307,0,.372-.051.42-.354.017-.1.015-.211.024-.349l.914.052a1.176,1.176,0,0,1-.524,1.055,3.237,3.237,0,0,1-2.928.076,1.235,1.235,0,0,1-.583-1.157"
          transform="translate(-6.743 -14.65)"
          fill={fill}
        />
        <path
          id="Path_13812"
          data-name="Path 13812"
          d="M28.809,4.113c.012-.312.022-.606.033-.9a1.258,1.258,0,0,1,1.381,1.064,3.429,3.429,0,0,1-.12,2.131,1.222,1.222,0,0,1-1.212.82q-.016-.446-.032-.892c.822-.1.661-.087.677-.836.007-.3,0-.608,0-.912,0-.337-.068-.417-.4-.456-.089-.01-.178-.009-.326-.017"
          transform="translate(-14.624 -1.628)"
          fill={fill}
        />
        <path
          id="Path_13813"
          data-name="Path 13813"
          d="M27.34,42.609a2.585,2.585,0,0,1-.654-.024c-.09-.026-.176-.233-.179-.359-.018-.91-.013-1.821-.015-2.731,0-.041,0-.082.005-.123a.456.456,0,1,1,.908-.078c.024.458.019.918.019,1.377,0,.517,0,1.034-.01,1.55a2.592,2.592,0,0,1-.074.389"
          transform="translate(-13.448 -19.732)"
          fill={fill}
        />
        <path
          id="Path_13814"
          data-name="Path 13814"
          d="M27.327,12.319A2.141,2.141,0,0,1,26.7,12.3c-.1-.032-.191-.243-.194-.376-.019-.9-.014-1.8-.017-2.706,0-.041,0-.082,0-.123a.47.47,0,0,1,.741-.428.436.436,0,0,1,.167.32c.022.5.019,1,.02,1.5,0,.484,0,.967-.011,1.451a2.281,2.281,0,0,1-.083.38"
          transform="translate(-13.446 -4.358)"
          fill={fill}
        />
        <path
          id="Path_13815"
          data-name="Path 13815"
          d="M26.584,28.916a1.815,1.815,0,0,1,.612,0,.5.5,0,0,1,.215.39c.019.828.008,1.656.007,2.484,0,.074,0,.148,0,.221.019.524-.153.675-.666.573-.229-.046-.258-.235-.259-.418-.007-.6,0-1.2,0-1.8,0-.336-.008-.672,0-1.008a2.852,2.852,0,0,1,.093-.448"
          transform="translate(-13.444 -14.663)"
          fill={fill}
        />
        <path
          id="Path_13816"
          data-name="Path 13816"
          d="M27.312,22.457a2.2,2.2,0,0,1-.608-.034.453.453,0,0,1-.2-.346c-.025-.467-.013-.936-.013-1.4,0-.485,0-.97,0-1.454,0-.333.1-.452.4-.451.425,0,.525.091.522.455-.007.952-.008,1.905-.018,2.857a2,2,0,0,1-.086.376"
          transform="translate(-13.444 -9.527)"
          fill={fill}
        />
        <path
          id="Path_13817"
          data-name="Path 13817"
          d="M12.305,26.579a2.144,2.144,0,0,1,0,.623.466.466,0,0,1-.365.209c-.918.02-1.837.013-2.756.015-.041,0-.082,0-.123,0a.486.486,0,0,1-.384-.772.477.477,0,0,1,.342-.14c.713-.015,1.427-.01,2.141-.012.262,0,.525,0,.787.006a2.4,2.4,0,0,1,.359.075"
          transform="translate(-4.355 -13.45)"
          fill={fill}
        />
        <path
          id="Path_13818"
          data-name="Path 13818"
          d="M42.642,27.335a2.018,2.018,0,0,1-.378.084c-.918.008-1.837.008-2.755.007a.628.628,0,0,1-.313-.037.508.508,0,0,1-.24-.288c-.059-.5.036-.6.537-.6.926,0,1.853-.005,2.779.012.123,0,.32.1.349.194a2.434,2.434,0,0,1,.022.632"
          transform="translate(-19.767 -13.449)"
          fill={fill}
        />
        <path
          id="Path_13819"
          data-name="Path 13819"
          d="M32.592,26.611a2.05,2.05,0,0,1-.02.618c-.033.1-.245.194-.378.2-.812.017-1.624.007-2.437.006a4.426,4.426,0,0,1-.492,0c-.185-.021-.357-.078-.356-.321,0-.512.02-.568.348-.576.844-.02,1.689-.019,2.533-.026a3.588,3.588,0,0,1,.418,0,2.834,2.834,0,0,1,.384.1"
          transform="translate(-14.675 -13.452)"
          fill={fill}
        />
        <path
          id="Path_13820"
          data-name="Path 13820"
          d="M18.5,26.6a1.959,1.959,0,0,1,.4-.1c.951-.007,1.9-.006,2.854,0,.279,0,.416.109.415.306,0,.507-.046.582-.4.587-.951.013-1.9.027-2.853.017a.5.5,0,0,1-.394-.206,1.793,1.793,0,0,1-.02-.6"
          transform="translate(-9.382 -13.451)"
          fill={fill}
        />
        <path
          id="Path_13821"
          data-name="Path 13821"
          d="M27.335,2.99a2.389,2.389,0,0,1-.658-.026c-.1-.03-.18-.247-.183-.382-.018-.721-.008-1.444-.009-2.166,0-.343.093-.418.529-.416.308,0,.406.1.405.417,0,.722,0,1.444,0,2.167a2.5,2.5,0,0,1-.081.407"
          transform="translate(-13.443 0)"
          fill={fill}
        />
        <path
          id="Path_13822"
          data-name="Path 13822"
          d="M.037,26.563a1.8,1.8,0,0,1,.323-.069q1.132-.007,2.265,0c.311,0,.383.109.382.518,0,.292-.108.41-.393.411q-1.12.005-2.241,0c-.263,0-.376-.112-.374-.375,0-.157.024-.313.037-.484"
          transform="translate(0 -13.446)"
          fill={fill}
        />
        <path
          id="Path_13823"
          data-name="Path 13823"
          d="M27.36,51.759a3.659,3.659,0,0,1-.689-.02c-.177-.038-.175-.224-.174-.39,0-.657,0-1.315,0-1.973,0-.342.083-.441.4-.441.458,0,.533.067.531.437-.005.674,0,1.348-.006,2.022a2.731,2.731,0,0,1-.06.365"
          transform="translate(-13.448 -24.841)"
          fill={fill}
        />
        <path
          id="Path_13824"
          data-name="Path 13824"
          d="M51.739,27.354a1.615,1.615,0,0,1-.305.073q-1.072.007-2.145,0c-.242,0-.345-.1-.354-.342,0-.09,0-.181,0-.271a.277.277,0,0,1,.3-.314q1.122-.008,2.243,0a.267.267,0,0,1,.289.3c0,.181-.018.363-.029.552"
          transform="translate(-24.839 -13.451)"
          fill={fill}
        />
        <path
          id="Path_13825"
          data-name="Path 13825"
          d="M23.132,24.688a1.322,1.322,0,0,1,1.4-1.305,1.319,1.319,0,0,1,.023.166c.006.245.008.49.012.733-.3.074-.693-.077-.745.438l-.693-.032"
          transform="translate(-11.742 -11.869)"
          fill={fill}
        />
        <path
          id="Path_13826"
          data-name="Path 13826"
          d="M28.843,30.128c.021-.3.041-.589.061-.879.628-.075.628-.075.671-.455l.673.04a1.291,1.291,0,0,1-1.4,1.294"
          transform="translate(-14.641 -14.616)"
          fill={fill}
        />
        <path
          id="Path_13827"
          data-name="Path 13827"
          d="M30.211,24.712l-.679,0c-.059-.364-.084-.379-.8-.441.029-.281.059-.572.089-.863a1.292,1.292,0,0,1,1.394,1.306"
          transform="translate(-14.583 -11.877)"
          fill={fill}
        />
        <path
          id="Path_13828"
          data-name="Path 13828"
          d="M23.17,28.812c.147,0,.293-.008.439-.009a.246.246,0,0,1,.278.2c.039.111.223.184.356.243a.965.965,0,0,0,.31.024q.014.44.028.872a1.324,1.324,0,0,1-1.411-1.325"
          transform="translate(-11.761 -14.621)"
          fill={fill}
        />
      </g>
    </svg>
  );
};
